module.exports = __webpack_public_path__ + "static/media/Apple2.dce650f4.png";